import type { I_SafetyEventLabel } from "../interfaces";

export interface I_SamsaraLabelOption {
  label: string;
  name: string;
}

export const SAMSARA_LABEL_TYPES: I_SamsaraLabelOption[] = [
  { label: "acceleration", name: "Acceleration" },
  { label: "braking", name: "Braking" },
  { label: "collision", name: "Collision" },
  { label: "crash", name: "Crash" },
  { label: "defensiveDriving", name: "Defensive Driving" },
  { label: "didNotYield", name: "Did Not Yield" },
  { label: "distractedDriving", name: "Distracted Driving" },
  { label: "drowsy", name: "Drowsy" },
  { label: "eatingDrinking", name: "Eating / Drinking" },
  { label: "followingDistance", name: "Following Distance" },
  { label: "forwardCollisionWarning", name: "Forward Collision Warning" },
  { label: "genericDistraction", name: "Generic Distraction" },
  { label: "HardBraking", name: "Hard Braking" },
  { label: "harshAcceleration", name: "Harsh Acceleration" },
  { label: "harshBraking", name: "Harsh Braking" },
  { label: "harshTurn", name: "Harsh Turn" },
  { label: "laneDeparture", name: "Lane Departure" },
  { label: "lateResponse", name: "Late Response" },
  { label: "maxSpeed", name: "Max Speed" },
  { label: "mobileUsage", name: "Mobile Usage" },
  { label: "nearCollison", name: "Near Collision" },
  { label: "nearPedestrianCollisions", name: "Near Pedestrian Collision" },
  { label: "noSeatbelt", name: "No Seatbelt" },
  { label: "obstructedCamera", name: "Obstructed Camera" },
  { label: "ranRedLight", name: "Ran Red Light" },
  { label: "rollingStop", name: "Rolling Stop" },
  { label: "severeSpeeding", name: "Severe Speeding" },
  { label: "smoking", name: "Smoking" },
  { label: "speeding", name: "Speeding" },
  { label: "unsafeLeftTurn", name: "Unsafe Left Turn" },
  { label: "unsafeParking", name: "Unsafe Parking" },
  { label: "unsafeReversing", name: "Unsafe Reversing" },
  { label: "unsafeUTurn", name: "Unsafe U-Turn" },
];

export function toLabelPayload(labelKey: string): I_SafetyEventLabel {
  const match = SAMSARA_LABEL_TYPES.find((t) => t.label === labelKey);
  return {
    label: labelKey,
    name: match?.name ?? labelKey,
    source: "user",
  };
}
